    export const toastSearch = ({
      title: 'Search something.',
      description: "You must write at least 4 characters to search.",
      status: 'error',
      duration: 6000,
      isClosable: true,
    })
  

